import axios from "axios";

export default {
  getPreview(token) {
    return axios.get(`/invites/${encodeURIComponent(token)}`).then((response) => {
      return response.data.data.invite;
    });
  },

  join(token) {
    return axios.post(`/invites/${encodeURIComponent(token)}/join`).then((response) => {
      return response.data.data.membership;
    });
  },
};
